import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import P1 from "../../../../components/paragraph";
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '30px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 24}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                  <div>
                                    <h2 id="how-to-accept-rent-payments-online">Automate Your Business With MOGUL AI</h2>
                                    
                                    <p>MOGUL property management software uses AI to automate repetitive tasks, eliminate errors and improves efficiency so you focus on what matters.
                                      
                                      MOGUL frees up your time so you can focus on increasing the tenant experience. MOGUL also automates tenant tasks such as leasing, rent payment and
                                      maintenacne requests, so tenants spend less time communicating with you and more time enjoying their home.
                                    </p>

                                    <p>
                                       MOGUL increases tenant satisfaction thus ensuring the steady, timely inflow of rental income.
                                    </p>
                                  </div>
                                </P1>                   
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
